import React, { FunctionComponent, } from 'react'
import { useTranslation } from 'react-i18next';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';

import './Imprint.css';
import { useDispatch, } from 'react-redux';
import { AppDispatch, } from '../../store/store';
import { Button } from '@mui/material';
import { push } from '@lagunovsky/redux-react-router';

interface Props {
}

const Imprint:FunctionComponent<Props> = () => {

  const { t } = useTranslation( [ 'imprint' ]);
  const dispatch = useDispatch<AppDispatch>();

  const onClick = () => {
    dispatch( push( '/' ) );
  };

  return (<AuthLayout header={ true }>
    <h2>{ t( 'header' ) }</h2>
    <div className="page page-imprint">
      <div className="page-imprint__content">
        { t( 'content' ) }
      </div>
        <Button
          onClick={ onClick }
          fullWidth
          variant='contained'
        >{ t( 'back' ) }</Button>
    </div>
  </AuthLayout>)

}

export default Imprint;
